import { render } from "./ScrollPane.vue?vue&type=template&id=1b6c2485&scoped=true"
import script from "./ScrollPane.vue?vue&type=script&lang=ts"
export * from "./ScrollPane.vue?vue&type=script&lang=ts"

import "./ScrollPane.vue?vue&type=style&index=0&id=1b6c2485&lang=scss&scoped=true"
import "./ScrollPane.vue?vue&type=style&index=1&id=1b6c2485&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1b6c2485"

export default script